<template>
  <div class="container-fluid">
    <!-- Title -->
    <div class="row flex-row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Trial Balance
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
        <!-- <div @click="goBack">
          <span class="s-18 fw-400 cursor-pointer text-black">
            <img src="../../../assets/goback.png" alt="" /> Go back</span
          >
        </div> -->
      </div>
      <div class="c-pointer">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dark w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  class="no-decoration text-dark"
                  @click="downloadFile(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <div class="row bg-gray-300 justify-content-center py-3 border-radius-8">
      <div class="col-md-12 pl-4">
        <div class="row align-items-center">
          <div class="col-md-8 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12">
                <div class="text-md-right text-left s-14 fw-400 text-dak">
                  Date Range
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="col-md-12 mt-3 d-flex justify-content-center justify-content-md-end px-0"
            >
              <el-button
                class="c-pointer w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="generateReport"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Accounts Table -->
    <div class="mt-5 row" id="element-to-print">
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <div v-if="bookTypeItem == 'pdf'" class="row d-none">
          <table
            class="table remove-styles mt-0 col-md-12 table-hover table-header-area"
          >
            <thead>
              <tr>
                <th>
                  <div class="row">
                    <div class="col-md-12 d-flex justify-content-between">
                      <div>
                        <div class="s-20 fw-500">Trial Balance Report</div>
                        <div class="s-18 font-weight-600">
                          {{ tenantDisplayName }}
                        </div>
                        <div class="s-18 fw-500">
                          <span class="mr-1"> Date Range: </span>
                          <span>
                            {{ formatDate(startDate) }}
                            to {{ formatDate(endDate) }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <img
                          :src="churchLogo"
                          v-if="churchLogo"
                          class="link-image mr-2"
                          alt=""
                        />
                        <img
                          src="../../../assets/dashboardlinks/churchcloud.png"
                          v-else
                          class="link-image mr-2"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <table
          id="table"
          class="table remove-styles mt-0 table-hover table-header-area"
        >
          <thead class="table-header-ar">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right">DEBIT</th>
              <th class="text-right">CREDIT</th>
            </tr>
          </thead>

          <!-- Dynamic sections for each account category -->
          <tbody
            v-for="(category, categoryName) in groupedAccounts"
            :key="categoryName"
          >
            <!-- Category Header -->
            <tr class="table-header-area-main fw-400 s-14">
              <th class="fw-400 text-dak s-14" colspan="3">
                {{ categoryName }}
              </th>
            </tr>

            <!-- Account rows -->
            <tr v-for="(account, index) in category.accounts" :key="index">
              <td class="fw-500 text-blue-400 s-12">
                {{ account.accountName }}
              </td>
              <td class="text-right">{{ formatAmount(account.debit) }}</td>
              <td class="text-right">{{ formatAmount(account.credit) }}</td>
            </tr>

            <!-- Category Total -->
            <tr class="font-weight-bold">
              <td class="text-dak font-weight-bold s-14">
                Total {{ categoryName }}
              </td>
              <td class="text-right text-dak font-weight-bold s-14">
                {{ formatAmount(category.totalDebit) }}
              </td>
              <td class="text-right text-dak font-weight-bold s-14">
                {{ formatAmount(category.totalCredit) }}
              </td>
            </tr>
          </tbody>

          <!-- Grand Total -->
          <tbody>
            <tr
              class="font-weight-bold"
              style="border-bottom: 1px solid rgba(0, 0, 1, 0.2) !important"
            >
              <td class="text-dak font-weight-bold s-14">
                Total for all accounts
              </td>
              <td
                class="text-right text-dak font-weight-bold s-14"
                style="
                  border-bottom: 1px solid #000000 !important;
                  border-top: 1px solid #000000 !important;
                "
              >
                {{ formatAmount(grandTotalDebit) }}
              </td>
              <td
                class="text-right text-dak font-weight-bold s-14"
                style="
                  border-bottom: 1px solid #000000 !important;
                  border-top: 1px solid #000000 !important;
                "
              >
                {{ formatAmount(grandTotalCredit) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watchEffect, watch, nextTick, inject } from "vue";
import axios from "@/gateway/backendapi";
import { useStore } from "vuex";
import exportService from "../../../services/exportFile/exportserjs";
import dateFormatter from "../../../services/dates/dateformatter";
import { ElNotification } from "element-plus";

// Date & Filters
// const selectedYear = ref(2025);
const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
const endDate = ref(new Date(Date.now()));
const years = ref([2023, 2024, 2025, 2026]);
const loading = ref(false);
const accountsData = ref([]);
const store = useStore();
const bookTypeItem = ref("");
const tenantData = ref({});
const churchLogo = ref("");
const primarycolor = inject("primarycolor");
// const reportType = ref([
//   { name: "Accrual (Paid and Unpaid)", id: 1 },
//   { name: "Accrual", id: 2 },
//   { name: "Cash Basis", id: 3 },
// ]);

const fileName = ref("Trial balance Report");
const bookTypeList = ref([
  { name: "xlsx" },
  { name: "csv" },
  { name: "txt" },
  { name: "pdf" },
]);
const branchItem = ref({});
branchItem.value = JSON.parse(localStorage.getItem("branchItem"));

// const selectedFileType = ref({});
const fileHeaderToExport = ref([]);
const fileToExport = ref([]);

const downloadFile = async (item) => {
  try {
    if (item.name === "pdf") {
      bookTypeItem.value = item.name;
      await new Promise((resolve) => setTimeout(resolve, 3)); // 100ms delay
    }

    exportService.downLoadExcel(
      item.name,
      document.getElementById("element-to-print"),
      fileName.value,
      fileHeaderToExport.value,
      fileToExport.value
    );
    ElNotification.success({ message: "Export completed!" });
  } catch (error) {
    ElNotification.error({ message: "Export failed!" });
  }
};

// const setSelectedYear = () => {
//   selectedYear.value = years.value.find((i) => i === selectedYearID.value);
// };
// const setSelectReportType = () => {
//   selectReportType.value = reportType.value.find(
//     (i) => i.id === selectReportTypeID.value
//   );
// };

// Sample Data

// Computed Totals

const getChurchProfile = async () => {
  if (branchItem.value && branchItem.value.id) {
    try {
      let { data } = await axios.get(
        `/GetChurchProfileById?tenantId=${branchItem.value.id}`
      );
      churchLogo.value = data.returnObject.logo;
    } catch (err) {
      console.error(err);
    }
  } else {
    try {
      let { data } = await axios.get(
        `/GetChurchProfileById?tenantId=${getUser.value.tenantId}`
      );
      churchLogo.value = data.returnObject.logo;
    } catch (err) {
      console.error(err);
    }
  }
};
const getUser = computed(() => {
  if (
    !store.getters.currentUser ||
    (store.getters.currentUser &&
      Object.keys(store.getters.currentUser).length == 0)
  )
    return "";
  return store.getters.currentUser;
});

watchEffect(() => {
  if (getUser.value) {
    tenantData.value = getUser.value;
    getChurchProfile();
  }
});

// getChurchProfile();

const tenantDisplayName = computed(() => {
  if (!tenantData.value.churchName) return "";
  const name =
    tenantData.value.churchName.length < 20
      ? tenantData.value.churchName
      : `${tenantData.value.churchName.slice(0, 20)}...`;
  return name;
});
const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};
// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });

const getTrialBalance = async () => {
  if (branchItem.value && branchItem.value.id) {
    try {
      const { data } = await axios.get(
        `/api/BranchReports/financials/getTrialBalanceRepor?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}&branchId=${branchItem.value.id}`
      );

      accountsData.value = data.items;
      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getTrialBalanceReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}`
      );

      accountsData.value = data.items;
      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  }
};
getTrialBalance();
const groupedAccounts = computed(() => {
  const groups = {};

  // Group accounts by category
  accountsData.value.forEach((account) => {
    if (!groups[account.accountType]) {
      groups[account.accountType] = {
        accounts: [],
        totalDebit: 0,
        totalCredit: 0,
      };
    }

    groups[account.accountType].accounts.push(account);
    groups[account.accountType].totalDebit += account.debit;
    groups[account.accountType].totalCredit += account.credit;
  });

  return groups;
});

const grandTotalDebit = computed(() => {
  return Object.values(groupedAccounts.value).reduce((total, category) => {
    return total + category.totalDebit;
  }, 0);
});

const grandTotalCredit = computed(() => {
  return Object.values(groupedAccounts.value).reduce((total, category) => {
    return total + category.totalCredit;
  }, 0);
});

const generateReport = async () => {
  if (branchItem.value && branchItem.value.id) {
    try {
      const { data } = await axios.get(
        `/api/BranchReports/financials/getTrialBalanceReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}&branchId=${branchItem.value.id}`
      );

      accountsData.value = data.items;
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getTrialBalanceReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}`
      );

      accountsData.value = data.items;
    } catch (error) {
      console.log(error);
    }
  }
};
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
@media print {
  .pdf-only {
    display: block;
  }

  .no-print {
    display: none;
  }
}
</style>
